// Textos de las pantallas (tal cual del diseño).

/** Textos de 1.10, tal cual del diseño (y el aprobado de G123 para el otro email). */
export const TEXTOS_INVITACION = {
    titulo: (quien: string, negocio: string) => `${quien} te invita a ${negocio}`,
    entrarasComo: (roles: readonly string[]) => `Entrarás como ${roles.join(' • ')}.`,
    sinVerificar: 'No hace falta verificar el email: la invitación te ha llegado a él.',
    aceptar: 'Aceptar la invitación',
    yaTienesCuenta: '¿Ya tienes cuenta en Reservaria?',
    entrarYAceptar: 'Entrar y aceptar',
    caducada: 'Esta invitación ha caducado',
    caducadaSub: (quien: string | null) => (quien === null ? 'Caducan a los 7 días.' : `Caducan a los 7 días. Pídele otra a ${quien}.`),
    yaFormasParte: '¿Ya formas parte del equipo?',
    otroEmail: 'Es otro email',
    paraEmail: (email: string) => `La invitación es para ${email}.`,
    volverALaInvitacion: 'Volver a la invitación',
    faltaNombre: 'Escribe tu nombre y apellidos.',
} as const;
